angular.module('bbl.models.bridge', [])
  .factory('BridgeModel', ['Api.http', '$q', 'pubsub', '$filter', BridgesModelFactory]);

/**
 * BridgesModelFactory
 *   pubsub model - allow to subscribe to "fetch" event
 */
function BridgesModelFactory(Api, $q, pubsub, $filter) {
  var types = {
    ON_FETCH: 'api:bridges:fetch:complete',
  };

  function findBridgeNumber(bridge) {
    return bridge.dids.filter(function(did) {
      return did.primary;
    })[0] || {};
  }

  function onFetchComplete(response) {
    pubsub.pub(types.ON_FETCH, response.objects.map(function(bridge) {
      var number = findBridgeNumber(bridge).number;

      return angular.extend(bridge, {
        bridge_number: number,
        friendly_phone: $filter('cLineFm')(number),
      });
    }));

    return response;
  }

  function fetch() {
    return Api.fetch.apply(0, [].concat.apply([Api.urls.bridges], arguments))
    .then(onFetchComplete);
  }

  function fetchOne() {
    return Api.fetchOne.apply(0, [].concat.apply([Api.urls.bridges], arguments))
    .then(function(bridge) {
      var number = findBridgeNumber(bridge).number;
      return angular.extend(bridge, {
        bridge_number: number,
        friendly_phone: $filter('cLineFm')(number),
      });
    });
  }

  function mergeRoom(room) {
    return Api.save('/bridges/api/v1/merge_close/'+room+'/');
  }

  function reconstituteRooms(bridge) {
    return Api.save('/bridges/api/v1/reconstitute/'+bridge+'/');
  }

  function hangupRoom(bridge, room_id) {
    return Api.get('/bridges/api/v1/hangup_all/'+bridge+'/', {room_id: room_id});
  }

  function hangupBridge(bridge) {
    var bridgeId = bridge.id || bridge;
    var prefix = (bridge || {}).service_provider === 'node-cc' ? '/call-control/boot_all/' : '/bridges/api/v1/hangup_all/';
    return Api.get(prefix + bridgeId + '/');
  }

  function muteRoom(bridge) {
    console.warn('not implemented');
    // return Api.save('bridges/api/v1/control_reconstitute/'+bridge+'/');
  }

  function muteBridge(bridge, toggle) {
    return Api.calls.toggleStatus('mute_all', bridge, '');
  }

  function toggleHoldMute(conferenceId) {
    return Api.get('/bridges/api/v1/toggle-hold-mute/'+conferenceId+'/');
  }

  function addPerson(bridge, person, params, opts) {
    if (bridge.service_provider === 'node-cc') {
      return Api.get('/call-control/missing-one/'+bridge.id+'/'+person, params, opts);
    }

    return Api.get(Api.urls.add_person+bridge.id+'/'+person+'/', params, opts);
  }

  function joinZoomMeeting(person, params, opts) {
    return Api.get(Api.urls.join_zoom_meeting+person+'/', params, opts);
  }

  function deleteDid(id) {
    return Api.saveOne(Api.urls.delete_did, id, {});
  }

  return Api.extend('bridges', {
    fetch: fetch,
    fetchOne: fetchOne,
    addPerson: addPerson,
    joinZoomMeeting: joinZoomMeeting,
    save: Api.save.bind(0, Api.urls.bridges),
    update: Api.update.bind(0, Api.urls.bridges),

    sub: pubsub._sub.bind(0, types.ON_FETCH),
    once: pubsub.once.bind(0, types.ON_FETCH),

    broadcastSms: Api.saveForm.bind(0, Api.urls.bridges_send_sms),
    mergeRoom: mergeRoom,
    reconstituteRooms: reconstituteRooms,
    hangupRoom: hangupRoom,
    muteRoom: muteRoom,

    hangupBridge: hangupBridge,
    muteBridge: muteBridge,
    deleteDid: deleteDid,
    toggleHoldMute: toggleHoldMute,
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/models/bridge.js
 ** module id = 128
 ** module chunks = 0
 **/